import Component from '@glimmer/component';
import { computed } from '@ember/object';

export default class PublicPost extends Component {

  @computed('args.model.singlePosts.posts.[]')
  get post() {
    return this.args.model.singlePosts.posts.findBy('postItemId', this.args.model.postId);
  }
}